import { Component, Input } from '@angular/core';

import { CommonService } from '../../services/common.service';
import { Score } from '../../model/dashboards.model';

@Component({
  selector: 'good-average-poor-card',
  templateUrl: './good-average-poor-card.component.html',
  styleUrls: ['./good-average-poor-card.component.scss'],
})
export class GoodAveragePoorCardComponent {
  @Input() scores: Array<Score> = [];
  @Input() cardTitle: string;
  @Input() titleIconName?: string = '';

  constructor(public cService: CommonService) {}
}
